import { useRouter } from 'next/router';

import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

export function useBeat(beatId?: string) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();
  const router = useRouter();

  console.log('🔍 [useBeat] beatId:', beatId, 'router.isReady:', router.isReady, 'token:', !!token);

  const {
    data = {},
    error,
    isLoading
  } = useQuery({
    queryKey: 'client-beat',
    queryData: beatId,
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/client/campaign/beat/${beatId}`,
        token
      }).then((response: Api.Beat | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    enabled: !!token && !!beatId && router.isReady
  });

  return {
    isLoading,
    error,
    data
  };
}
